(function () {
  const toggle = document.querySelector('.site-header__toggle');
  const nav = document.querySelector('.site-header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const form = picker.closest('form');
    const idInput = form?.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const buyBtn = document.querySelector('[data-buy-button]');
    const buyLabel = buyBtn?.dataset.buyLabel || 'Add to cart';

    picker.querySelectorAll('[data-variant]').forEach((btn) => {
      btn.addEventListener('click', () => {
        picker.querySelectorAll('[data-variant]').forEach((b) =>
          b.setAttribute('aria-checked', 'false')
        );
        btn.setAttribute('aria-checked', 'true');
        if (idInput) idInput.value = btn.dataset.variant;
        const price = btn.dataset.price;
        const available = btn.dataset.available === 'true';
        if (priceEl && price) priceEl.textContent = price;
        if (buyBtn) {
          buyBtn.disabled = !available;
          buyBtn.textContent = available
            ? `${buyLabel} — ${price}`
            : 'Sold out';
        }
      });
    });
  });
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const countEl = gallery.querySelector('[data-gallery-count]');
    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    const slides = track ? track.querySelectorAll('.product__gallery-slide') : [];
    const total = slides.length;

    function pad(n) { return String(n).padStart(3, '0'); }

    function currentIndex() {
      if (!track || total === 0) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function updateCount() {
      if (countEl && total > 1) {
        countEl.textContent = `${pad(currentIndex() + 1)} / ${pad(total)}`;
      }
    }

    function goTo(index) {
      if (!track) return;
      const clamped = Math.max(0, Math.min(index, total - 1));
      track.scrollTo({ left: track.clientWidth * clamped, behavior: 'smooth' });
    }

    function syncVideos() {
      const idx = currentIndex();
      slides.forEach((slide, i) => {
        const video = slide.querySelector('[data-gallery-video]');
        if (!video) return;
        if (i === idx) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    if (track) {
      track.addEventListener('scroll', () => { updateCount(); syncVideos(); }, { passive: true });
    }
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex() - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex() + 1));

    syncVideos();
  }
})();
